export function getPreviousSiblings(elem, filter) {
    const sibs = [];
    while ((elem = elem.previousSibling)) {
        if (elem.nodeType === 3) continue;
        if (!filter || filter(elem)) sibs.push(elem);
    }
    return sibs;
}

export const eventTargetOrClosest = (e, selector) => {
    const { target } = e;
    return target.classList.contains(selector)
        ? target
        : target.closest(`.${selector}`);
};

//this function requires secure connection (https)
export function copyToClipboard(value) {
    if (!value) {
        return false;
    };

    navigator.clipboard.writeText(value);
    return true;
}
